module.exports = __webpack_public_path__ + "img/9788990828545.068ce296.jpg";